import { RegionType } from './RegionType.enum';
import { Viewport } from './Viewport.component';
import { TopPanel } from './TopPanel.component';
import { CenterPanel } from './CenterPanel.component';
import { CollapsibleSidePanel } from './CollapsibleSidePanel.component';
import { LayoutContext } from './LayoutContext';

export default {
	RegionType,
	Viewport,
	TopPanel,
	CenterPanel,
	CollapsibleSidePanel,
	LayoutContext,
};
